import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=d63d3690&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=ts&"
export * from "./Iframe.vue?vue&type=script&lang=ts&"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=d63d3690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63d3690",
  null
  
)

export default component.exports